import { getBuyerName } from "../Components/Includes/Layouts/Common/BuyerBasedOnDomain";

export const getQueryString = () => {
  const {brand,b_id}  = getBuyerName();
  const full_url = window.location.href;
  const query_string_arr = full_url.split("?");
  if (query_string_arr && query_string_arr[1]) {
    let queryString = query_string_arr[1];
    if (queryString.includes("b_id=")) {
      queryString = queryString.replace(
        /(b_id=)[^&]*/,
        `$1${b_id}`
      );
    }
    localStorage.setItem('savedQueryString', queryString);
    return queryString;
  } else {
    const savedQueryString = localStorage.getItem('savedQueryString');
    return savedQueryString ? savedQueryString : '';
  }
}


